// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"440":"ea5c91f1","581":"3ee60d88","760":"6142005a","941":"cf0d9a75"}[chunkId] + ".chunk.js";
};